import { setTheme } from "theme/default/setTheme";

export const setColor_e8e8e8 = setTheme(({ theme }) => `color: ${theme.colors.color_e8e8e8}`);
